import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "new_components/AdvisoryServices/AdvisoryServices.scss";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import ComingSoon from "new_assets/new_images/Builders/coming_soon.png";
import axios from "axios";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
// import ComingSoon from "new_assets/new_images/Builders/coming_soon.png";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
import PreLoad from "new_components/PreLoad/PreLoad";
import HomeBottomBanner from "new_components/Home/HomeBottomBanner";
const AdvisoryServices = () => {
  return (
    <>
      <ScrollToTopDefault />
      <ProgressCircle />
      <Header />
      <Body />
      <Footer />
    </>
  );
};

const Body = () => {
  return (
    <div>
      <AdvisoryBanner />
      <AdvisoryContent />
      <OurAdvisoryServiceincludes />
      <AdvisoryChoose />
      <ContactUs />
      <HomeBottomBanner />

      {/* <QuoteSection /> */}
    </div>
  );
};

const AdvisoryBanner = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const Preload = () => {
    return (
      <div className="preload preload-container">
        <div className="preload-logo">
          <div className="spinner" />
          <span className="icon icon-villa-fill" />
        </div>
      </div>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.advisoryServicesBannerText);

        if (response.data?.status === "success" && response.data?.data) {
          setData(response.data.data);
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div>
        <Preload />
      </div>
    );
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <section className="flat-section">
      <div className="container">
        <div
          className="row align-items-center justify-content-center wow fadeInUp propertymanagementbanner mx-md-5 px-1 px-md-5"
          style={{
            backgroundImage: `url(${Image_Base_URL + data.image})`,
          }}
          data-wow-delay=".2s"
        >
          <div className="col-12 text-center">
            <p className="subtitle text-white body-2 wow fadeInUp">
              {data.title1}{" "}
            </p>
            <h3 className="title text-white">{data.title2}</h3>
          </div>
          <div className="col-12 align-items-left mt-3">
            <p
              className="subtitle text-white body-2 wow fadeInUp px-5"
              dangerouslySetInnerHTML={{
                __html: data.description,
              }}
            ></p>
            {data?.button_text && data?.button_url && (
              <button
                className="tf-btn btn-view primary hover-btn-view ml-5 mt-3"
                onClick={() => {
                  const url = new URL(data.button_url, window.location.origin);
                  window.open(url.toString(), "_blank");
                }}
              >
                {data.button_text}
                <span className="icon icon-arrow-right2"></span>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

const AdvisoryContent = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.advisoryContentSection);
        if (response.data.status === "success" && response.data?.data) {
          setData(response.data.data); // Get the first object from the data array
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <section className="flat-section bg-primary-new">
      <div className="container">
        <div
          className="row align-items-center justify-content-center wow fadeInUp"
          data-wow-delay=".2s"
        >
          <div className="col-12 col-md-4 text-center mb-2">
            <img
              src={`${Image_Base_URL}${data.image}`}
              alt="Investment strategy illustration"
            />
          </div>
          <div className="col-12 col-md-8">
            <div
              className="investmentphildata note body-2"
              dangerouslySetInnerHTML={{
                __html:
                  data.paragraph1 ||
                  "Welcome to Lucky Duck Group Advisory Services!",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const OurAdvisoryServiceincludes = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.advisoryServiceIncludes);
        // console.log("API response for advisory service includes:", response.data?.data.cards); // Debugging log
        if (response.data.status === "success") {
          setData(response.data.data); // Get the first object from the data array
          // console.log("Advisory Service Includes data:", response.data.data.title); // Debugging log
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <section className="flat-section">
      <div className="container">
        <div className="box-title wow fadeInUp mx-0 mb-3">
          <h3 className="mt-4 title text-uppercase">{data?.title}</h3>
          <p className="mt-2 body-2">{data?.subtext}</p>
        </div>
        <div
          className="tf-grid-layout lg-col-4 md-col-4 sm-col-2 wow fadeInUp mb-3"
          data-wow-delay=".2s"
        >
          {data?.cards?.map((item, index) => {
            return (
              <div className="box-service" key={index}>
                <div className="content text-start fw-bold pb-1 w-100">
                  {item.card_title}
                </div>
                <div className="content text-start">{item.card_text}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
const ContactUs = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.advisorycontactus);
        if (response.data.status === "success" && response.data.data) {
          setData(response.data.data); // Get the first object from the data array
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <section className="flat-section bg-primary-new">
      <div className="container">
        <div
          className="row align-items-center justify-content-center wow fadeInUp"
          data-wow-delay=".2s"
        >
          <div className="col-12 col-md-4 text-center mb-2">
            <img
              src={`${Image_Base_URL}${data.image}`}
              alt="Investment strategy illustration"
            />
          </div>
          <div className="col-12 col-md-8 text-center text-sm-start">
            <h6
              className="investmentphildata note title mb-sm-2 mb-1 fw-bold"
              dangerouslySetInnerHTML={{
                __html:
                  data.main_title ||
                  "Welcome to Lucky Duck Group Advisory Services!",
              }}
            />
            <div
              className="investmentphildata note title mb-sm-3 mb-2 fw-bold"
              dangerouslySetInnerHTML={{
                __html:
                  data.title ||
                  "Welcome to Lucky Duck Group Advisory Services!",
              }}
            />
            <Link
              to={data.btn_url}
              className="tf-btn btn-view primary hover-btn-view ml-5 "
            >
              {data.btn_text}{" "}
              <span className="icon icon-arrow-right2"></span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );  
};
const AdvisoryChoose = () => {
  const [chooseData, setchooseData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.advisorychoose);
        if (response.data.status === "success") {
          setchooseData(response.data.data); // Access the "data" array from the response
          setLoading(false);
        }
      } catch (err) {
        setError("Failed to fetch Advisory Choose data.");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <section className="row advdualbannerlistingrow">
      <div className="col-12 col-md-9 advdualbannerlistingone text-start p-3">
        <h6 className="title text-white text-start w-100 pb-2 fw-bold">{chooseData.title}</h6>
        {/* <p className="body-2 text-white">{item.sub_title}</p> */}
        <div className="text-white body-2">{chooseData.description}</div>
        {/*  <Link to={item.button_link} className="tf-btn btn-view primary hover-btn-view ml-5 dualbannerlistingonebtn">
              {item.button_text} <span className="icon icon-arrow-right2 dualbannerlistingonebtnicon"></span>
            </Link>*/}
      </div>
      <div
        className="col-12 col-md-3 advdualbannerlistingsecpic"
        style={{
          backgroundImage: `url(${Image_Base_URL}${chooseData.image})`, // Dynamically set background image
        }}
      ></div>
    </section>
  );
};


export default AdvisoryServices;
